import { NavigateFunction } from 'react-router-dom';

interface NavigateOptions {
    /** Replace the current entry in the history stack instead of pushing a new one */
    replace?: boolean;
    /** Adds persistent client side routing state to the next location */
    state?: any;    
}

let navigateFunction: NavigateFunction | null = null;

export const setNavigate = (navigate: NavigateFunction) => {
  navigateFunction = navigate;
};

export const navigateTo = (path: string, state?: NavigateOptions) => {
  if (navigateFunction) {
    navigateFunction(path, state);
  }
};
